import { AloftPrice, SiteRating, isDefined, schAloftArea } from '@aloft/toolkit-shared';

import { sortBySiteSize } from './utils.ts';
import type { SiteSizeVsSiteValueGraphChartData } from './SiteSizeVsSiteValueGraphChart.tsx';

type SiteEntityLite = {
  area?: unknown;
  influenceRating?: SiteRating;
  viewRating?: SiteRating;
};

export const getSiteSizeVsSiteValueGraphExportData = (
  compSequence: string[] | undefined,
  siteEntities: Record<string, SiteEntityLite | undefined>,
  siteValues: Record<string, AloftPrice | undefined>,
): SiteSizeVsSiteValueGraphChartData[] => {
  const seq = compSequence ?? [];

  return sortBySiteSize(
    ['subject', ...seq]
      .map((id, index) => {
        const isSubject = id === 'subject';
        const compNumber = isSubject ? undefined : index;

        const { area, influenceRating, viewRating } = siteEntities[id] ?? {};
        const siteValue = siteValues[id];

        if (!area || !siteValue) return undefined;

        return {
          propertyName: isSubject ? 'Subject' : `Comp ${compNumber}`,
          influenceRating,
          viewRating,
          label: `${influenceRating?.charAt(0).toLocaleUpperCase() ?? '-'}${viewRating?.charAt(0).toLocaleUpperCase() ?? '-'}`,
          siteSize: schAloftArea.parse(area).getUnitAmount('sqft'),
          siteValue: siteValue.toDollarLike(),
          compNumber,
        };
      })
      .filter(isDefined),
  );
};
